"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinuteMenu = exports.HourMenu = exports.TimeDisplay = void 0;
var react_1 = __importDefault(require("react"));
var utils_1 = require("./utils");
function TimeDisplay(_a) {
    var _b, _c;
    var time = _a.time, onClick = _a.onClick, back = _a.back;
    return react_1.default.createElement("div", { className: 'time-display' },
        back != null && react_1.default.createElement("i", { className: "back fa fa-arrow-left", onClick: back }),
        react_1.default.createElement("span", { className: 'hour', onClick: function () { return onClick("hour"); } }, (0, utils_1.pad)((_b = time === null || time === void 0 ? void 0 : time.hour) !== null && _b !== void 0 ? _b : 0)),
        ":",
        react_1.default.createElement("span", { className: 'minute', onClick: function () { return onClick("minute"); } }, (0, utils_1.pad)((_c = time === null || time === void 0 ? void 0 : time.minute) !== null && _c !== void 0 ? _c : 0)));
}
exports.TimeDisplay = TimeDisplay;
function trigger(onChange, n) {
    return function () { return onChange(n); };
}
function HourMenu(_a) {
    var time = _a.time, onClick = _a.onClick, onChange = _a.onChange, back = _a.back;
    var cells = [];
    for (var i = 0; i <= 23; i++) {
        cells.push(react_1.default.createElement("div", { key: i, className: "hour ".concat(i === time.hour ? 'selected' : ''), onClick: trigger(onChange, i) }, (0, utils_1.pad)(i)));
    }
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TimeDisplay, { time: time, onClick: onClick, back: back }),
        react_1.default.createElement("div", { className: "hour-menu" }, cells));
}
exports.HourMenu = HourMenu;
function MinuteMenu(_a) {
    var time = _a.time, onClick = _a.onClick, onChange = _a.onChange, back = _a.back;
    var cells = [];
    for (var i = 0; i <= 55; i += 5) {
        cells.push(react_1.default.createElement("div", { key: i, className: "minute ".concat(i === time.minute ? 'selected' : ''), onClick: trigger(onChange, i) }, (0, utils_1.pad)(i)));
    }
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TimeDisplay, { time: time, onClick: onClick, back: back }),
        react_1.default.createElement("div", { className: "minute-menu" }, cells));
}
exports.MinuteMenu = MinuteMenu;
//# sourceMappingURL=components.js.map